import { RowsPlusTopIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const RowsPlusTop = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <RowsPlusTopIcon color={fill} size={Sizes[size]} {...rest} />;
};

RowsPlusTop.displayName = 'RowsPlusTop';
